export default __webpack_public_path__ + "static/book2-69b4bf4f8ae7b416e19ee5a648cad371.jpg";